import { render, staticRenderFns } from "./ExpensesDataTable.vue?vue&type=template&id=5a27250b"
import script from "./ExpensesDataTable.vue?vue&type=script&lang=js"
export * from "./ExpensesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports